import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import { initializeApp, FirebaseOptions } from "firebase/app";
import { getPerformance } from "firebase/performance";
import { initializeAnalytics } from "firebase/analytics";

if (environment.production) {
  enableProdMode();
}

// only enable firebase features and Clarity for prod
if (environment.env === "prod") {
  const firebaseConfig: FirebaseOptions = {
    apiKey: "AIzaSyBMtqtKd0XkuDKO4AN9f-7eCBnRT3bIfyo",
    authDomain: "astute-synapse-95314.firebaseapp.com",
    projectId: "astute-synapse-95314",
    storageBucket: "astute-synapse-95314.appspot.com",
    messagingSenderId: "543477738215",
    appId: "1:543477738215:web:a2f5aea9844cfb47ac9042",
    measurementId: "G-HDH8M6YM6Y"
  };
  const firebaseApp = initializeApp(firebaseConfig);
  initializeAnalytics(firebaseApp, {config: {debug: true}});
  getPerformance(firebaseApp);

  // Microsoft Clarity
  const clarityWindow = window as unknown as { clarity: { (...args: unknown[]): void, q?: unknown[] } };
  clarityWindow.clarity = clarityWindow.clarity || function(...args: unknown[]) {
    (clarityWindow.clarity.q = clarityWindow.clarity.q || []).push(args);
  };
  const clarityScript = document.createElement("script");
  clarityScript.async = true;
  clarityScript.src = "https://www.clarity.ms/tag/ylq366q74p";
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode?.insertBefore(clarityScript, firstScript);
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
